import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import QUESTIONS from './questions';
import tokens from '../theme/tokens';

// 고객 질문 전광판 — 한 줄씩 아래에서 올라오며 바뀐다(기본 3.2초). 마우스를 올리면 멈추고, 움직임 줄이기 설정이면 바로 바뀐다
const useStyles = makeStyles(() => ({
  strip: {
    display: 'flex',
    alignItems: 'center',
    height: 38,
    padding: '0 14px',
    borderTop: `1px solid ${tokens.primaryLine}`,
    backgroundColor: tokens.primarySoft,
    overflow: 'hidden',
  },
  item: { display: 'flex', alignItems: 'center', minWidth: 0, flex: '1 1 auto', animation: '$roll .45s ease-out' },
  who: {
    flex: 'none',
    height: 22,
    marginRight: 8,
    padding: '0 8px',
    borderRadius: 11,
    border: `1px solid ${tokens.primaryLine}`,
    backgroundColor: tokens.surface,
    color: tokens.primaryDark,
    fontSize: 11,
    fontWeight: 700,
    lineHeight: '20px',
    letterSpacing: -0.3,
  },
  text: { flex: '1 1 auto', minWidth: 0, fontSize: 13, letterSpacing: -0.5, color: tokens.ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
  dense: { height: 34, padding: '0 12px', '& $text': { fontSize: 12 } },
  '@keyframes roll': {
    from: { opacity: 0, transform: 'translateY(70%)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  '@media (prefers-reduced-motion: reduce)': {
    item: { animation: 'none' },
  },
}));

function VehicleCheckTicker({ lines = QUESTIONS, interval = 3200, dense = false, className }) {
  const cs = useStyles();
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused || lines.length < 2) return undefined;
    const id = setInterval(() => setIndex((i) => (i + 1) % lines.length), interval);
    return () => clearInterval(id);
  }, [paused, lines.length, interval]);

  const line = lines[index % lines.length];
  return (
    <div className={clsx(cs.strip, dense && cs.dense, className)} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} aria-live="off">
      <span key={index} className={cs.item}>
        <span className={cs.who}>{line.who}</span>
        <span className={cs.text}>{line.text}</span>
      </span>
    </div>
  );
}

export default VehicleCheckTicker;
